'use client'

import * as React from 'react'
import { cn } from '../../../../../lib/utils'

export type QueryExpressionType = 'AND' | 'OR' | 'OPEN_PAREN' | 'CLOSE_PAREN'

export type QueryExpressionProps = {
  type: QueryExpressionType
  onDelete?: () => void
  isDeleteMode?: boolean
  onDeleteModeChange: (isDeleteMode: boolean) => void
}

const getExpressionLabel = (type: QueryExpressionType): string => {
  switch (type) {
    case 'AND':
      return 'AND'
    case 'OR':
      return 'OR'
    case 'OPEN_PAREN':
      return '('
    case 'CLOSE_PAREN':
      return ')'
    default:
      return ''
  }
}

export const QueryExpression: React.FC<QueryExpressionProps> = ({
  type,
  onDelete,
  isDeleteMode: externalIsDeleteMode,
  onDeleteModeChange,
}) => {
  const isDeleteMode = externalIsDeleteMode ?? false
  const label = getExpressionLabel(type)

  const handleDeleteClick = () => {
    onDeleteModeChange(true)
  }

  const handleTriggerClick = () => {
    if (isDeleteMode) {
      onDeleteModeChange(false)
    }
  }

  return (
    <div
      className={cn(
        'inline-flex items-stretch p-0.5 px-0 rounded-md text-2xs group transition-colors whitespace-nowrap relative',
        isDeleteMode && 'bg-foreground/20',
      )}
    >
      {/* Delete button */}
      {isDeleteMode && (
        <button
          onClick={onDelete}
          className="absolute -top-1.5 -right-1.5 p-1.5 rounded-full bg-foreground/50 hover:bg-foreground/80 transition-colors"
        ></button>
      )}

      {/* Expression label with delete trigger */}
      <div
        className={cn(
          'hover:bg-accent/90 transition-colors rounded-md',
          isDeleteMode && 'bg-accent/20',
        )}
      >
        <button
          onClick={handleDeleteClick}
          className="px-1.5 py-0.5 flex items-center gap-1 text-xs min-w-fit h-full w-full"
        >
          <span className="truncate">{label}</span>
        </button>
      </div>
    </div>
  )
}
